export function normalizeGpxPointsInput(raw) {
  const toPoints = (value) => {
    if (!Array.isArray(value)) return [];
    return value
      .filter((point) => Array.isArray(point) && point.length >= 2)
      .map((point) => point.map((coord) => Number(coord) || 0));
  };

  if (Array.isArray(raw)) return toPoints(raw);

  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return toPoints(parsed);
      if (parsed && typeof parsed === "object") {
        return toPoints(
          parsed.gpx_points || parsed.gpxPoints || parsed.points || [],
        );
      }
    } catch {
      return [];
    }
    return [];
  }

  if (raw && typeof raw === "object") {
    return toPoints(raw.gpx_points || raw.gpxPoints || raw.points || []);
  }

  return [];
}

export function parseGpxText(text) {
  const parser = new DOMParser();
  const xml = parser.parseFromString(text, "application/xml");
  const trkpts = Array.from(xml.getElementsByTagName("trkpt") || []);
  const points = trkpts.length
    ? trkpts.map((node) => {
        const lat = parseFloat(node.getAttribute("lat") || "0");
        const lon = parseFloat(node.getAttribute("lon") || "0");
        const eleNode = node.getElementsByTagName("ele")[0];
        const ele = eleNode
          ? parseFloat(eleNode.textContent || "")
          : undefined;
        return ele != null && !Number.isNaN(ele) ? [lat, lon, ele] : [lat, lon];
      })
    : Array.from(xml.getElementsByTagName("rtept") || []).map((node) => {
        const lat = parseFloat(node.getAttribute("lat") || "0");
        const lon = parseFloat(node.getAttribute("lon") || "0");
        return [lat, lon];
      });

  if (!points.length) {
    throw new Error("No GPX points found");
  }

  return points;
}

export function findNearestGpxPointIndex(points, lat, lng) {
  if (!Array.isArray(points) || points.length === 0) return -1;

  let bestIndex = -1;
  let bestDistance = Infinity;

  for (let index = 0; index < points.length; index += 1) {
    const point = points[index];
    if (!Array.isArray(point) || point.length < 2) continue;
    const dLat = (Number(point[0]) || 0) - lat;
    const dLng = (Number(point[1]) || 0) - lng;
    const distance = dLat * dLat + dLng * dLng;
    if (distance < bestDistance) {
      bestDistance = distance;
      bestIndex = index;
    }
  }

  return bestIndex;
}

export function sliceGpxSubset(points, startIndex, endIndex) {
  if (!Array.isArray(points) || points.length < 2) return [];
  const from = Math.min(startIndex, endIndex);
  const to = Math.max(startIndex, endIndex);
  return points.slice(from, to + 1).map((point) => (Array.isArray(point) ? [...point] : point));
}

export function flattenSequencedGpxFiles(gpxFiles = []) {
  return (gpxFiles || [])
    .slice()
    .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))
    .flatMap((file) => normalizeGpxPointsInput(file?.gpx_points || file?.gpxPoints || []));
}